import { Flex } from "@/storybook-components";
import type { Projects } from "@/types";
import { useAppSelector } from "@/redux/store/hooks";
import Filter from "./menu-filter";

const Menu = ({ projects }: Projects): JSX.Element => {
  const { error, queryFilter } = useAppSelector((state) => state.projectFinder);

  const {
    showSearch,
    showTagsFilter,
    showStateFilter,
    showYearFilter,
    showResetFilter
  } = queryFilter;

  if (
    (!showSearch &&
      !showTagsFilter &&
      !showStateFilter &&
      !showYearFilter &&
      !showResetFilter) ||
    error
  ) {
    return null;
  }

  return (
    <Flex
      mb="7px"
      pb="5px"
      align="center"
      borderBottom="1px solid #f4f4f4"
      className="ehq-projectsMenuContainer"
      flexDirection={["column", "column", "row", "row"]}
    >
      <Filter projects={projects} />
    </Flex>
  );
};

export default Menu;
